import React from "react";
import css from "./Form.css";
import Footer from 'common/Footer';
import StyledButton from 'common/StyledButton';
import DateRange from './DateRange';
import PropTypes from "prop-types";
import Moment from "moment";
import StickyFooterLayout from 'common/StickyFooterLayout';

const Form = props => {

  const getContent = () => (
    <div className ={css['content']}>
      <h3 className={"sf-admin-title"}>System Announcements</h3>
      <div className={css['staff-block']}>
        <h4>Staff Announcement</h4>
        <p>Enter the staff announcement here. Refer to Starfish Help for the allowed HTML.</p>
        <div className={css['input']}>
          <textarea data-role='staffAnnouncement'
            value={props.staffAnnouncement}
            onChange={e => props.setStaffAnnouncement(e.target.value)}/>
        </div>
      </div>

      <div className={css['student-block']}>
        <h4 className={css['student-title']}>Student Announcement</h4>
        <p>Enter the student announcement here. Date fields are optional. You may enter a start date, an end date, or
          both. All dates entered are inclusive. Refer to Starfish Help for the allowed HTML.</p>
        <div className={css['input']}>
          <textarea data-role='studentAnnouncement'
            value={props.studentAnnouncement}
            onChange={e => props.setStudentAnnouncement(e.target.value)}/>
          <div className={css['date-range']}>
            <DateRange
              startDate={props.startDate}
              setStartDate={props.setStartDate}
              endDate={props.endDate}
              setEndDate={props.setEndDate}
              isClearable/>
          </div>
        </div>
      </div>
    </div>
  );

  const getFooter = () => {
    return (
      <Footer
        className ={css['system-announcement-footer']}
        primaryButton={(
          <StyledButton data-role="saveSystemAnnouncements" onClick={props.onSave}>Save</StyledButton>
        )}
        secondaryButton={(
          <StyledButton asLink onClick={props.resetAnnouncements}>Cancel</StyledButton>
        )}
      />
    )
  };

  return (<StickyFooterLayout content={getContent()} footer={getFooter()} className={'sys-announcements'} />)

};

Form.propTypes = {
    startDate: PropTypes.instanceOf(Moment),
    setStartDate: PropTypes.func.isRequired,
    endDate: PropTypes.instanceOf(Moment),
    setEndDate: PropTypes.func.isRequired,
    resetAnnouncements: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    studentAnnouncement: PropTypes.string,
    setStudentAnnouncement: PropTypes.func.isRequired,
    staffAnnouncement: PropTypes.string,
    setStaffAnnouncement: PropTypes.func.isRequired,
};

export default Form;
